import { Sanitization, piiInterceptor } from '@ringcx/pii-interceptor';

piiInterceptor.appendOrOverrideDefaultMaskRules({
    number: Sanitization.hashBySHA256,
});

export * from './RCXLogger';
export * from './decorator';
